/**
 * @fileoverview This is a higher order component that watches the
 * window for resize events and sends down the size of the parent
 * container to children. This powers our responsive charts.
 */

import React from 'react'
import Resize from '../../services/resize'
import { getBreakpoint } from './breakpoints'
import { string } from 'prop-types'

import '../../styles/components/chart-resize-frame.css'

export default function injectSizeFactory(
  Component,
  { dedupe } = { dedupe: false }
) {
  class InjectSize extends React.PureComponent {
    state = {
      ready: false,
      width: 1,
      height: 1
    }

    static contextTypes = {
      breakpoint: string
    }

    componentDidMount() {
      this.resize()
      Resize.listen(this.resize, this)
    }

    componentWillUnmount() {
      Resize.ignore(this.resize, this)
    }

    getBreakpoint(width) {
      return this.context.breakpoint || getBreakpoint(width)
    }

    shouldResize(current, previous) {
      if (!current || !previous) {
        return true
      }

      const breakpoint = this.getBreakpoint(current.width)

      if (
        breakpoint === 'small' &&
        current.width === previous.width &&
        dedupe
      ) {
        return false
      }

      return true
    }

    resize(dimensions, previousDimensions) {
      if (this.shouldResize(dimensions, previousDimensions)) {
        this.setState({
          ready: true,
          width: Math.max(this.refs.frame.offsetWidth, 1),
          height: Math.max(this.refs.frame.offsetHeight, 1)
        })
      }
    }

    render() {
      const { ready, width, height } = this.state
      const breakpoint = this.getBreakpoint(width)

      let props = { ...this.props, width, height, breakpoint }

      return (
        <div className="chart-resize-window" ref="frame">
          {ready ? React.createElement(Component, props) : null}
        </div>
      )
    }
  }

  return InjectSize
}



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/inject-size.js